import { render, staticRenderFns } from "./UserStatsComponent.vue?vue&type=template&id=56af8f2a&"
import script from "./UserStatsComponent.vue?vue&type=script&lang=js&"
export * from "./UserStatsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports